
import {
  bananDetail,
  insteadTroduce,
  insteadTroduceCustomized,
  getProductInfo
} from '@/services/http';
import { Component, Vue } from 'vue-property-decorator';
import Header from '@/common/header.vue';
import Footer from '@/common/footer.vue';
import BackTop from '@/common/backtop.vue';
import { readCookie } from '@/tools/tools';

@Component({
  components: {
    Header,
    Footer,
    BackTop
  }
})
export default class extends Vue {
  // 展示图片
  bannerList: any[] = []

  // 0代打印，1耗材定制
  type: number = Number(this.$route.query.type)

  created() {
    this.getBannerDetails();
  }

  async getBannerDetails() {
    const { id, type, from } = this.$route.query;
    if (from === 'carousel') {
      const res: any = await bananDetail({
        id,
        channel: 1,
        type
      });
      this.bannerList = res.data.data.detail;
    } else if (from === 'details') {
      const anchor = readCookie('anchor');
      const res: any = await getProductInfo({
        productId: this.$route.query.id,
        model: anchor ? anchor.model : '',
        equipMeid: anchor ? anchor.equipMeid : '',
        src: anchor ? (anchor.src ? anchor.src : 2) : 4,
        equip: anchor ? anchor.equip : 4,
        version: anchor ? anchor.version : '',
        companyId: 1
      });
      this.bannerList = res.data.data.product.descPics;
    } else if (this.type === 0) {
      const res: any = await insteadTroduce({
        id
      });
      this.bannerList = res.data.data.detail;
    } else {
      const res: any = await insteadTroduceCustomized({
        id
      });
      this.bannerList = res.data.data.detail;
    }
  }
}
